import React from 'react';
import { useRouter } from 'next/router';
import { logEvent } from 'firebase/analytics';
import { ApplicationLayout } from '../../components/commons';
import { steps } from '../../components/steps';
import { loadAnalytics } from '../../lib';

export default function RequestScholarship() {
  const router = useRouter();
  const [step, setStep] = React.useState(steps[0]);
  React.useEffect(
    function syncRoute() {
      if (router.query && router.query.id && Array.isArray(router.query.id)) {
        const query = Number(router.query.id[0]) - 1;
        if (query < 0 || query >= steps.length) {
          router.push('/request-scholarship/[...id]', `/request-scholarship/1`);
        } else {
          setStep(steps[query]);
        }
      }
    },
    [router, router.query]
  );

  React.useEffect(
    function () {
      logEvent(loadAnalytics(), 'page_view', {
        page_title: step.name,
      });
    },
    [step?.name]
  );

  return (
    <ApplicationLayout step={step}>
      {React.cloneElement(step.component as any)}
    </ApplicationLayout>
  );
}
